module.exports = __webpack_public_path__ + "img/amex.5645420f.png";